import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_5 = ["id", "type", "placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col", [_ctx.isForm ? 'complaint-form-group' : 'space-y-0.5' ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        class: _normalizeClass(["form-label", _ctx.currentError ? 'form-error' : '']),
        for: _ctx.id
      }, [
        _createTextVNode(_toDisplayString(_ctx.label), 1 /* TEXT */),
        (_ctx.required)
          ? (_openBlock(), _createElementBlock("sup", _hoisted_3, "*"))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_2),
      (!_ctx.required)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Opcional"))
        : _createCommentVNode("v-if", true)
    ]),
    _withDirectives(_createElementVNode("input", {
      id: _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.inputValue) = $event)),
      type: _ctx.type,
      class: _normalizeClass([
          'w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 placeholder:font-light',
          _ctx.isForm
            ? (_ctx.currentError ? 'border-red-500' : 'border-gray-300')
            : (_ctx.currentError ? 'border-red-500' : 'border-gray-800'),
          _ctx.isForm
            ? 'border rounded-md p-2 text-gray-500 placeholder:text-gray-300 mt-1'
            : 'form-input p-2 placeholder:text-gray-400 text-gray-600 placeholder:italic'
        ]),
      placeholder: _ctx.placeholder,
      onBlur: _cache[1] || (_cache[1] = $event => {_ctx.validateInput(); _ctx.$emit('blur')}),
      onFocus: _cache[2] || (_cache[2] = $event => (_ctx.$emit('focus')))
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5), [
      [_vModelDynamic, _ctx.inputValue]
    ]),
    _createElementVNode("span", {
      class: _normalizeClass([_ctx.currentError ? 'h-4 opacity-100' : 'opacity-0', "text-sm text-red-500"])
    }, _toDisplayString(_ctx.currentError), 3 /* TEXT, CLASS */)
  ], 2 /* CLASS */))
}